var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("sidebar-widget", {
    attrs: {
      title: _vm.$gettext("Import"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "ul",
              {
                staticClass: "widget-list widget-links cw-import-widget",
              },
              [
                _c(
                  "li",
                  {
                    staticClass: "cw-import-widget-archive",
                  },
                  [
                    _c(
                      "button",
                      {
                        on: {
                          click: function click($event) {
                            return _vm.setShowUnitImportDialog(true)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Lernmaterial importieren")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "cw-import-widget-copy",
                  },
                  [
                    _c(
                      "button",
                      {
                        on: {
                          click: function click($event) {
                            return _vm.setShowUnitCopyDialog(true)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Lernmaterial kopieren")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }